import type { DomainOffersEntry } from '@/pages/useCalculateOffers';

let skierCountOffersPrefetch: { key: string; entries: DomainOffersEntry[] } | null = null;

export function setSkierCountOffersPrefetch(
  payload: { key: string; entries: DomainOffersEntry[] } | null
): void {
  skierCountOffersPrefetch = payload;
}

export function takeSkierCountOffersPrefetchIfKeyMatches(key: string): DomainOffersEntry[] | null {
  if (!skierCountOffersPrefetch || skierCountOffersPrefetch.key !== key) return null;
  const { entries } = skierCountOffersPrefetch;
  skierCountOffersPrefetch = null;
  return entries;
}
